import { FC, createElement } from 'react';
import { Upper } from './styled';

export enum Type {
  h1,
  h2,
  h3,
  h4,
  h5,
}

type Props = {
  children: any;
  type?: Type;
  uppercase?: boolean;
};

// Heading type
const renderHeadingType = (text: string, type: Type) =>
  createElement(`h${type + 1}`, null, text);

// Uppercase
const renderWithUppercase = (children: any) => <Upper>{children}</Upper>;

const Heading: FC<Props> = ({
  children,
  type = Type.h1,
  uppercase = false,
}) => {
  const headingType = renderHeadingType(children, type);
  if (uppercase) {
    return renderWithUppercase(headingType);
  }
  return headingType;
};

export default Heading;
